import { render, staticRenderFns } from "./TechForm.vue?vue&type=template&id=057ce5c4"
import script from "./TechForm.vue?vue&type=script&lang=js"
export * from "./TechForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports